export default __webpack_public_path__ + "c323dd758ee97cb36b25019bfe5efc35.png";